import { useState } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { NotificationManager } from 'react-notifications';
import { useMsal } from '@azure/msal-react';
import useFetchVendors from './useFetchVendors';
import { msalConfig } from '../auth/authConfig';
import { errorHandler } from '../utils/helpers';
import useUserStore from '../store/userStore';
import { acquireToken } from '../utils/auth';

interface DeleteVendorContactRequest {
  id: string | number;
  token: string | null;
  setError: (data: any) => any;
  setLoading: (data: any) => any;
  fetchVendors: () => void;
  userId: string | number;
};

const deleteVendorContactRequest = async ({
    token,
    setError,
    setLoading,
    fetchVendors,
    id,
    userId,
  }: DeleteVendorContactRequest) => {
  try {
    const response = await axios.delete(`${window.__env.REACT_APP_API_URL || process.env.REACT_APP_API_URL}/Vendor/Contact/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: 'application/json, text/plain, */*',
        userId,
      },
    });
    if (response.status === 200) {
      NotificationManager.success('Vendor Contact is successfully deleted');
    }
  } catch (error) {
    errorHandler(error, setError);
  } finally {
    fetchVendors();
    setLoading(false);
  }
};

interface DeleteVendorContact {
  deleteVendorContact: (id: string | number) => void;
  loading: boolean;
  error: Error | null;
};

const useDeleteVendorContact = (): DeleteVendorContact => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);
  const { fetchVendors } = useFetchVendors();
  
  const { user } = useUserStore();

  const deleteVendorContact = async (id) => {
    if (accounts.length > 0) {
      const accessTokenRequest = {
        scopes: [`${msalConfig.auth.clientId}/.default`],
        account: accounts[0],
      };

      if (!user) return navigate('/sign-in');

      try {
        const accessToken = await acquireToken(instance, accessTokenRequest);
        deleteVendorContactRequest({
          id,
          token: accessToken,
          setError,
          fetchVendors,
          setLoading,
          userId: user.id,
        });
      } catch (error) {
        errorHandler(error, setError);
      }
    } else {
      navigate('/sign-in');
    }
  }

  return { deleteVendorContact, loading, error };
};

export default useDeleteVendorContact;
